import styled from '@emotion/styled';

import AhavaLogo from '@app/ahava/assets/ahava-logo.svg?react';

export const WelcomeScreenWrapper = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => visible ? 'flex' : 'none'};
  border: 2px solid #fff;
  border-radius: 6px;
  flex-direction: column;
  align-items: center;
  color: #fff;
  padding: 70px 20px 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 40px 0;
    text-align: center;
    background: none;
    border: none;
    backdrop-filter: none;
  }
`;


export const H1Title = styled.h1`
  font-weight: 400;
  font-size: 20px !important;
  line-height: 110%;
  letter-spacing: 0.01rem;
  text-align: center;
  color: #B7925B;
  margin: 0 0 30px !important;
  text-transform: none;

  @media (max-width: 768px) {
    margin: 60px 0 30px !important;
    font-size: 18px !important;
  }
`;

export const H2Title = styled.h2`
  font-size: 20px !important;
  color: rgb(51, 51, 51) !important;
  text-align: center;
  padding: 0 20px;
  line-height: 30px;
  margin: 0 0 1rem !important;
  text-transform: none;

  @media (max-width: 768px) {
    margin: 0 !important;
    font-size: 20px !important;
  }
`;

export const Form = styled.form`
  display: flex;
  position: relative;
  margin: 40px auto 0;
  max-width: 100%;

  @media (max-width: 768px) {
    margin-top: 30px;
  }
  
  button {
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
  }
`;

export const TextArea = styled.textarea`
  width: 610px;
  height: 84px;
  padding: 6px 40px 6px 10px;
  font-family: "Benton Sans";
  max-width: 100%;
  font-size: 18px;
  line-height: 24px;
  overflow: hidden;
  letter-spacing: 0.01rem;
  color: #000;
  border: 1px solid #868383;
  box-shadow: 0px 0px 40px 0px #EDD5B9;
  border-radius: 6px;
  outline: none;
  resize: none;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const Prompts = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
  
  @media (max-width: 768px) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const PromptButton = styled.button<{ ready: boolean, index: number }>`
  display: flex;
  align-items: center;
  color: #000;
  gap: 5px;
  padding: 10px 15px;
  border-radius: 6px;
  background: none;
  box-shadow: none;
  background: rgba(255, 255, 255, 0.51);
  border: 1px solid rgba(134, 131, 131, 0.63);
  white-space: nowrap;
  cursor: pointer;
  font-size: 14px;
  visibility: ${({ ready }) => (ready ? 'visible' : 'hidden')};
  opacity: ${({ ready }) => ready ? 1 : 0};
  transform: ${({ ready }) => `translateX(${ready ? 0 : '200%'})`};
  transition: all 250ms ease-in-out;
  transition-delay: ${({ index }) => `${index * 50}ms`};
  
  &:disabled {
    opacity: .5;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.91);
  }
`;

export const SpinnerWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
`;

export const LogoImage = styled(AhavaLogo)`
  width: 60px;
  height: auto;
  display: inline-block;
  margin-bottom: 2px;
`;